import styles from "./GridComponent.module.css";

export default function GridComponent({
  kicker = "",
  heading = "",
  description = "",
  metrics = [],
  panelEyebrow = "",
  panelHeading = "",
  assurances = [],
}) {
  if (!heading) {
    return null;
  }

  return (
    <section className={styles.section}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.intro}>
          {kicker ? <span className={styles.kicker}>{kicker}</span> : null}
          <h2>{heading}</h2>
          {description ? <p>{description}</p> : null}
        </div>

        <div className={styles.layout}>
          <div className={styles.metricGrid}>
            {metrics.map((item) => (
              <article
                key={item.label}
                className={`${styles.metricCard} ${styles[item.style]}`}
              >
                <span className={styles.metricIcon}>{item.icon}</span>
                <strong>{item.value}</strong>
                <p>{item.label}</p>
              </article>
            ))}
          </div>

          <div className={styles.assurancePanel}>
            {panelEyebrow ? <span className={styles.panelEyebrow}>{panelEyebrow}</span> : null}
            <h3>{panelHeading}</h3>

            <div className={styles.assuranceList}>
              {assurances.map((item) => (
                <div key={item.label} className={styles.assuranceItem}>
                  <span className={styles.assuranceDot}>{item.icon}</span>
                  {item.label}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
